import { render } from "./SaveUnvalidModal.vue?vue&type=template&id=0877df5b"
import script from "./SaveUnvalidModal.vue?vue&type=script&lang=js"
export * from "./SaveUnvalidModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__